import { GetRelevantDataInterceptor } from './interceptors/get-relevant-data/get-relevant-data.interceptor';
import { ExternalModule } from './external.module';
import { ComponentsModule } from './components/components.module';
import { TemplatesModule } from './templates/templates.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, Injectable, Inject, InjectionToken, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { es as dateFnsEs } from 'date-fns/locale';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {NZ_DATE_LOCALE, NZ_I18N, es_ES} from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule } from '@angular/forms';

import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { AuthInterceptor } from './interceptors/auth-interceptor/auth-interceptor.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from './pipes/pipes.module';
import { IsLoggedInterceptor } from './interceptors/is-logged/is-logged.interceptor';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgScrollbarModule } from 'ngx-scrollbar';
import Rollbar from 'rollbar';
import { environment } from '../environments/environment';
import {NgxsStates} from './ngxs.states';
import {NetworkCacheInterceptor} from './interceptors/network-cache/network-cache.interceptor';
registerLocaleData(es);




@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    AngularEditorModule,
    TemplatesModule,
    ExternalModule,
    PipesModule,
    ComponentsModule,
    NgScrollbarModule,
    NgxsModule.forRoot(NgxsStates),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    { provide: NZ_DATE_LOCALE, useValue: dateFnsEs },
    { provide: NZ_I18N, useValue: es_ES },
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: IsLoggedInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GetRelevantDataInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NetworkCacheInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
